import React, { useEffect, useState } from 'react';
import { Button, Slider } from 'antd';
import styles from './number-range-filter.module.sass';

const getMarks = ({ min = 0, max = 100 }) => {
  return [0, 25, 50, 75, 100]
    .filter((value) => value >= min && value <= max)
    .reduce((acc, item) => ({ ...acc, [item]: item }), {});
};

const NumberRangeFilter = ({
  defaultValue,
  confirm,
  onSubmit,
  onReset,
  limits,
  status,
}) => {
  const [value, setValue] = useState(defaultValue);

  useEffect(() => {
    setValue(defaultValue);
  }, [status]); // eslint-disable-line react-hooks/exhaustive-deps

  const handleChange = (range) => {
    setValue(range);
  };

  const handleReset = () => {
    onReset();
    confirm();
    setValue([0, 100]);
  };

  const handleSubmit = () => {
    confirm();
    onSubmit(value);
  };

  const marks = getMarks(limits);

  return (
    <div style={{ padding: 8, minHeight: '90px' }} className={styles.container}>
      <Slider
        range
        defaultValue={[0, 100]}
        value={value}
        marks={marks}
        step={1}
        included
        style={{ minWidth: 200 }}
        onChange={handleChange}
        min={limits.min}
        max={limits.max}
      />
      <Button
        style={{ float: 'right' }}
        type="primary"
        role="search"
        onClick={handleSubmit}
        size="small"
      >
        Apply
      </Button>
      <Button
        role="reset"
        style={{
          border: 'none',
          float: 'right',
          marginRight: '8px',
          color: '#3C9AE8',
        }}
        onClick={handleReset}
        size="small"
      >
        Clear
      </Button>
    </div>
  );
};

export default NumberRangeFilter;
